import { useState } from "react";
import { Loader2 } from "lucide-react";

import { SearchInput } from "components/ui";
import { Button } from "components/ui/Button";
import { Dialog } from "components/ui/Dialog";
import { DialogFooter } from "components/ui/Dialog/DialogFooter";
import { useNoteTemplates } from "features/templates/hooks/useNoteTemplates";

import styles from "./ChooseTemplateModal.module.css";

export const ChooseTemplateModal = ({ onSelect, isDisabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const { data: templates, isLoading } = useNoteTemplates();

  const filteredTemplates = templates?.filter((template) =>
    template.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (template) => {
    onSelect?.(template.note);
    setIsOpen(false);
    setSearch("");
  };

  return (
    <div className={styles.container}>
      <Button
        type="button"
        size="medium"
        variant="primary"
        onClick={() => setIsOpen(true)}
        disabled={isDisabled}
      >
        Select Template
      </Button>

      <Dialog
        open={isOpen}
        title="Choose template"
        width={600}
        onClose={() => setIsOpen(false)}
      >
        <SearchInput
          value={search}
          onChange={setSearch}
          placeholder="Search templates..."
          variant="standalone"
        />
        <div className={styles.templateListWrapper}>
          <div className={styles.templateList}>
            {isLoading ? (
              <div className={styles.loading}>
                <Loader2 className={styles.spinner} size={24} />
                <p>Loading templates...</p>
              </div>
            ) : filteredTemplates?.length ? (
              filteredTemplates.map((template) => (
                <div key={template.id} className={styles.templateItem}>
                  <div className={styles.templateInfo}>
                    <h4>{template.name}</h4>
                    <p className={styles.templateDate}>
                      {template.updated || template.created || "N/A"}
                    </p>
                  </div>
                  <Button
                    type="button"
                    size="small"
                    onClick={() => handleSelect(template)}
                  >
                    Use Template
                  </Button>
                </div>
              ))
            ) : (
              <div className={styles.noResults}>
                <p>No templates found</p>
              </div>
            )}
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setIsOpen(false)}>
            Cancel
          </Button>
        </DialogFooter>
      </Dialog>
    </div>
  );
};
